import { ReactNode } from "react";

export default function Chip({ children }: { children: ReactNode | string }) {
    return <span className="px-[12px] py-[5px] rounded-[32px] border border-[var(--colorMain)]">
        {children}
    </span>
}